import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
export const Error = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-2 text-red-500 text-sm">This field is required</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};